import apiClient from './client'

/**
 * Obtiene los comentarios de un evento
 */
export const getComentarios = async (idEvento) => {
  const response = await apiClient.get(`/api/radar/eventos/${idEvento}/comentarios`)
  // La respuesta tiene estructura: { code, payload: [...], message }
  return response.data
}

/**
 * Crea un nuevo comentario
 */
export const createComentario = async (idEvento, data) => {
  const response = await apiClient.post(
    `/api/radar/eventos/${idEvento}/comentarios`,
    data
  )
  // La respuesta tiene estructura: { code, payload: { idComentario, fechaCreacion, ... }, message }
  return response.data
}

/**
 * Actualiza un comentario existente
 */
export const updateComentario = async (idComentario, data) => {
  const response = await apiClient.put(`/api/radar/comentarios/${idComentario}`, data)
  // La respuesta tiene estructura: { code, payload: { comentarioActualizado: true }, message }
  return response.data
}

/**
 * Elimina un comentario
 */
export const deleteComentario = async (idComentario) => {
  const response = await apiClient.delete(`/api/radar/comentarios/${idComentario}`)
  // La respuesta tiene estructura: { code, payload: { comentarioEliminado: true }, message }
  return response.data
}
